import { useState } from "react";

import { AmountAdjuster } from "@components/AmountAdjuster";
import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { H2 } from "@components/Typography";
import { useModal } from "@hooks";
import { Translations, i18n } from "@i18n";
import { AdjustBalanceModalProps } from "./types";

const MIN_BALANCE = 0;
const MAX_BALANCE = 10_000;
const STEP = 100;

export const AdjustBalanceModal = ({ currentBalance, onUpdate }: AdjustBalanceModalProps) => {
  const { dismiss } = useModal();

  const [balance, setBalance] = useState(currentBalance);

  const props: OverlayProps = {
    cta: {
      primary: {
        title: i18n.t(Translations.TrumpSidecarTaxCalculationRouteUpdateCTA),
        onClick: () => {
          onUpdate(balance);
          dismiss();
        },
      },
    },
  };

  return (
    <Overlay {...props}>
      <H2>{i18n.t(Translations.TrumpSidecarTaxCalculationRouteAdjustBalanceTitle)}</H2>
      <Spacing size={SpacingSizes.M} />

      <AmountAdjuster
        amount={balance}
        onAmountChange={setBalance}
        min={MIN_BALANCE}
        max={MAX_BALANCE}
        step={STEP}
      />
      <Spacing size={SpacingSizes.M} />
    </Overlay>
  );
};
